import { Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { listingsWithUploads } from '../../api/services/listings';
import MyListing from '../../pages/Dashboard/Selling/Listing/MyListing';
import AdjustPriceModal from '../AdjustPriceModal/AdjustPriceModal';
import NiceModal from '@ebay/nice-modal-react';
import ListingImage from '../ListingImage/ListingImage';
import { useSelector } from 'react-redux';
// eslint-disable-next-line max-len
import { selectTransactionByListingId } from '../../store/selectors/transactions';
import { RootState } from '../../store/store';
import { ExternalStatus, UploadsType } from '@prisma/client';
import TransactionJourney from '../../pages/Transactions/TransactionJourney';

interface ListingCardProps {
  listing: listingsWithUploads;
  slim?: boolean;
  showEditButton?: boolean;
  showViewButton?: boolean;
  showAdjustPriceButton?: boolean;
  onClickView?: () => void;
}

const ListingCard: React.FC<ListingCardProps> = ({
  listing,
  slim = false,
  showEditButton = true,
  showViewButton = true,
  showAdjustPriceButton = true,
  onClickView,
}) => {
  const navigate = useNavigate();
  const transaction = useSelector((state: RootState) =>
    selectTransactionByListingId(state, listing.id)
  );
  const listingPhotos = listing.uploads?.filter(
    (upload) => upload.type === UploadsType.PHOTO
  );

  return (
    <Grid container p={2} spacing={2}>
      <Grid item xs={12} sm={2}>
        <ListingImage listing={listing} />
      </Grid>
      <Grid item xs={12} sm={8}>
        <MyListing
          listing={listing}
          slim={slim}
          isDemoListing={listing.id === 'demo-seller-listing-1'}
        />
      </Grid>
      <Grid
        item
        container
        xs={12}
        sm={2}
        direction="column"
        justifyContent="center"
        alignItems="stretch"
        spacing={1}
      >
        {listing.status !== 'APPROVED' && showEditButton && (
          <Grid item>
            <Button
              variant="contained"
              onClick={() => navigate(`/listings/${listing?.id}/edit`)}
              fullWidth
            >
              Edit
            </Button>
          </Grid>
        )}
        {showViewButton && (
          <Grid item>
            <Button
              variant="contained"
              onClick={() => {
                if (onClickView) {
                  onClickView();
                } else {
                  navigate(`/listings/${listing?.id}`);
                }
              }}
              fullWidth
              disabled={
                listing.status !== 'APPROVED' &&
                !(listing.status === 'PENDING' && listingPhotos?.length > 0)
              }
              data-tour={
                listing.id === 'demo-seller-listing-1'
                  ? 'demo-view-btn'
                  : undefined
              }
            >
              View
            </Button>
          </Grid>
        )}
        {listing.status === 'APPROVED' &&
          showAdjustPriceButton &&
          listing.externalStatus === ExternalStatus.ACTIVE && (
            <Grid item>
              <Button
                variant="contained"
                onClick={() => NiceModal.show(AdjustPriceModal, { listing })}
                fullWidth
                data-tour={
                  listing.id === 'demo-seller-listing-1'
                    ? 'demo-price-btn'
                    : undefined
                }
              >
                Adjust Price
              </Button>
            </Grid>
          )}
      </Grid>
      {transaction && (
        <Grid xs={12} item>
          <TransactionJourney
            transaction={transaction}
            listing={listing}
            borderless={true}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ListingCard;
